import { useState, type FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedback, setFeedback] = useState<{ type: 'success' | 'error'; message: string } | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setFeedback(null);

    try {
      setIsSubmitting(true);

      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Erro ao enviar mensagem' }));
        throw new Error(errorData.error || 'Erro ao enviar mensagem');
      }

      setFeedback({
        type: 'success',
        message: 'Mensagem enviada com sucesso. Vai receber uma confirmação por email em instantes.',
      });
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      setFeedback({
        type: 'error',
        message: error instanceof Error ? error.message : 'Erro ao enviar mensagem',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contacto" className="py-[60px] bg-[#020617] border-t border-b border-[#111827]">
      <div className="max-w-[1120px] mx-auto px-4">
        <h2 className="text-[1.8rem] mb-6 font-bold text-[#e5e7eb]">Contacto</h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div>
            <p className="text-[#cbd5f5] mb-4">
              Tem dúvidas sobre o serviço, pagamentos ou acessos à área do cliente?
              Envie-nos uma mensagem e responderemos com a maior brevidade possível.
            </p>
            <ul className="list-none p-0 mt-3">
              <li className="text-[0.95rem] text-[#e5e7eb]">
                E-mail: <a href="mailto:geral@tarot-online.com.pt" className="text-[#a5b4fc] hover:underline">geral@tarot-online.com.pt</a>
              </li>
            </ul>
          </div>

          <div className="bg-[radial-gradient(circle_at_top_left,rgba(148,163,184,0.2),rgba(15,23,42,0.95))] rounded-[18px] p-5 border border-[rgba(148,163,184,0.35)] shadow-[0_16px_35px_rgba(15,23,42,0.7)]">
            <form onSubmit={handleSubmit} className="flex flex-col gap-2.5">
              {feedback && (
                <div
                  className={`rounded-[10px] px-3 py-2 text-[0.88rem] border ${
                    feedback.type === 'success'
                      ? 'bg-green-500/10 border-green-500/40 text-green-300'
                      : 'bg-red-500/10 border-red-500/40 text-red-300'
                  }`}
                >
                  {feedback.message}
                </div>
              )}

              <label htmlFor="nome-contacto" className="text-[0.9rem] font-medium text-[#e5e7eb]">
                Nome
              </label>
              <input
                type="text"
                id="nome-contacto"
                placeholder="O seu nome"
                required
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                disabled={isSubmitting}
                className="rounded-[10px] border border-[#4b5563] px-2.5 py-2 text-[0.95rem] bg-[#020617] text-[#e5e7eb] outline-none focus:border-[#f97316] transition-colors"
              />

              <label htmlFor="email-contacto" className="text-[0.9rem] font-medium text-[#e5e7eb]">
                E-mail
              </label>
              <input
                type="email"
                id="email-contacto"
                placeholder="o-seu-email@exemplo.com"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                disabled={isSubmitting}
                className="rounded-[10px] border border-[#4b5563] px-2.5 py-2 text-[0.95rem] bg-[#020617] text-[#e5e7eb] outline-none focus:border-[#f97316] transition-colors"
              />

              <label htmlFor="mensagem" className="text-[0.9rem] font-medium text-[#e5e7eb]">
                Mensagem
              </label>
              <textarea
                id="mensagem"
                rows={4}
                placeholder="Explique-nos a sua questão"
                required
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                disabled={isSubmitting}
                className="rounded-[10px] border border-[#4b5563] px-2.5 py-2 text-[0.95rem] bg-[#020617] text-[#e5e7eb] outline-none focus:border-[#f97316] transition-colors resize-vertical"
              />

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full inline-flex items-center justify-center rounded-full px-4 py-2 text-[0.95rem] font-medium bg-gradient-to-br from-[#8b5cf6] to-[#ec4899] text-[#f9fafb] shadow-[0_8px_20px_rgba(15,23,42,0.6)] hover:translate-y-[-1px] hover:brightness-105 transition-all mt-2"
              >
                {isSubmitting ? 'A enviar...' : 'Enviar mensagem'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
